import React from "react";

const GameRulesModal = ({
  data,
  setSelectedRule,
  groupModal,
  closeModal,
  loading,
}) => {
  if (!groupModal) return null;

  return (
    <div className="positionOverlay">
      <div className="modalView">
        <div style={{display:"flex", justifyContent: 'flex-end', padding: '0 27px'}}>
        <button onClick={closeModal} className="close-btn" style={{fontSize: '30px'}}>
          &times;
        </button>
        </div>
        <h2 className="selectPositionTxt">SELECT GAME RULES</h2>
        {loading ? (
          <div className="loader"></div>
        ) : (
          <div className="row-view">
            <div className="gender-section">
              <h3 className="gender-heading">Male</h3>
              {data &&
                data.map((val, ind) => {
                  if (val.gender === "male") {
                    return (
                      <button
                        key={ind}
                        onClick={() => setSelectedRule(val)}
                        className="btn"
                      >
                        {val.ruleName}
                      </button>
                    );
                  }
                  return null;
                })}
            </div>
            <div className="gender-section">
              <h3 className="gender-heading">Female</h3>
              {data &&
                data.map((val, ind) => {
                  if (val.gender === "female") {
                    return (
                      <button
                        key={ind}
                        onClick={() => setSelectedRule(val)}
                        className="btn"
                      >
                        {val.ruleName}
                      </button>
                    );
                  }
                  return null;
                })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameRulesModal;
